export default "__VITE_ASSET__B_AB_hSr__"